export default __webpack_public_path__ + "static/media/phin.34ac3932.png";